exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container_from_WebBrowserUnsupported-css_1Ln {\n  text-align: center;\n  padding: 64px\n}\n.container_from_WebBrowserUnsupported-css_1Ln h1 {\n  color: #dc501a;\n}\n", ""]);

// exports
exports.locals = {
	"container": "container_from_WebBrowserUnsupported-css_1Ln"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??ref--3-2!./app/web/src/routes/unsupported/WebBrowserUnsupported.css
// module id = ./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/unsupported/WebBrowserUnsupported.css
// module chunks = 0